exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\nMixin to fix iOS safari sticky hover (use only as required)\n\n@include safari-hover-fix() {\n  property: default non-hover value;\n}\n*/\n/* --  Mixins SPECIFICALLY for base/buttons and patterns/buttons  -- */\n.referral-agreement[data-v-337bb7cf] {\n  margin-top: 1rem;\n}\n", ""]);

